import React, { useState, useRef, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const SearchBox = ({ alwaysOpen = false }) => {
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState('');
    const [isExpanded, setIsExpanded] = useState(alwaysOpen);
    const inputRef = useRef(null);

    useEffect(() => {
        if (alwaysOpen) setIsExpanded(true);
    }, [alwaysOpen]);

    const submitHandler = (e) => {
        e.preventDefault();
        if (keyword.trim()) {
            navigate(`/search/${keyword}`);
            if (!alwaysOpen) {
                setIsExpanded(false);
                setKeyword('');
            }
        }
    };

    const toggleSearch = (e) => {
        if (isExpanded || alwaysOpen) {
            if (keyword.trim()) {
                submitHandler(e);
            }
        } else {
            setIsExpanded(true);
            setTimeout(() => {
                inputRef.current?.focus();
            }, 100);
        }
    };

    // Close search when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (inputRef.current && !inputRef.current.contains(event.target) && !event.target.closest('.search-toggle-btn')) {
                if (!keyword && !alwaysOpen) setIsExpanded(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [keyword, alwaysOpen]);

    return (
        <div className={`d-flex align-items-center position-relative ${alwaysOpen ? 'w-100' : ''}`}>
            <AnimatePresence>
                {(isExpanded || alwaysOpen) && (
                    <motion.div
                        initial={alwaysOpen ? { width: '100%', opacity: 1 } : { width: 0, opacity: 0 }}
                        animate={alwaysOpen ? { width: '100%', opacity: 1 } : { width: '250px', opacity: 1 }}
                        exit={alwaysOpen ? {} : { width: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className={alwaysOpen ? 'flex-grow-1 me-2' : 'me-2'}
                    >
                        <Form onSubmit={submitHandler}>
                            <Form.Control
                                type='text'
                                name='q'
                                ref={inputRef}
                                onChange={(e) => setKeyword(e.target.value)}
                                placeholder='Search products, users...'
                                className='mr-sm-2 rounded-pill border-0 shadow-sm w-100'
                                style={{ paddingLeft: '15px' }}
                            ></Form.Control>
                        </Form>
                    </motion.div>
                )}
            </AnimatePresence>
            <Button
                variant="link"
                onClick={toggleSearch}
                className="search-toggle-btn text-walnut p-2"
                style={{ fontSize: '1.2rem' }}
            >
                <FaSearch />
            </Button>
        </div>
    );
};


export default SearchBox;